// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Banda inferior de instalación de la PWA.
 *
 * Flota por encima del contenido (z-index 1200: debajo de los modales, que van
 * en 9000) y respeta la zona segura del iPhone (\`env(safe-area-inset-bottom)\`).
 * Usa \`--bg-surface\` (opaca) y no \`--bg-card\`, que en los skins Lumina es
 * translúcida y dejaría el texto ilegible sobre un plano o una tabla.
 */

.pwa-install {
  position: fixed;
  left: 0.75rem;
  right: 0.75rem;
  bottom: calc(0.75rem + env(safe-area-inset-bottom, 0px));
  z-index: 1200;
  display: flex;
  align-items: center;
  gap: 0.75rem;
  padding: 0.7rem 0.85rem;
  border: 1px solid var(--border);
  border-radius: 14px;
  background: var(--bg-surface);
  color: var(--text-primary);
  box-shadow: var(--shadow-lg);
  animation: pwa-install-in 0.22s ease;
}

@keyframes pwa-install-in {
  from { opacity: 0; transform: translateY(12px); }
  to   { opacity: 1; transform: translateY(0); }
}

.pwa-install-icon {
  width: 38px;
  height: 38px;
  flex: none;
  display: grid;
  place-items: center;
  border-radius: 10px;
  background: rgba(var(--accent-rgb), 0.16);
  color: var(--accent-l, var(--accent));
}

.pwa-install-icon svg {
  width: 26px;
  height: 26px;
}

.pwa-install-text {
  flex: 1 1;
  min-width: 0;
  display: flex;
  flex-direction: column;
  gap: 2px;
  font-size: 0.8rem;
  line-height: 1.35;
  color: var(--text-secondary);
}

.pwa-install-text strong {
  font-size: 0.88rem;
  color: var(--text-primary);
}

.pwa-install-actions {
  display: flex;
  align-items: center;
  gap: 0.4rem;
  flex: none;
}

.pwa-install-btn,
.pwa-install-later {
  border-radius: 9px;
  padding: 0.45rem 0.85rem;
  font: inherit;
  font-size: 0.82rem;
  font-weight: 700;
  cursor: pointer;
  white-space: nowrap;
}

.pwa-install-btn {
  border: 0;
  background: linear-gradient(135deg, var(--accent), var(--accent-dark));
  color: #fff;
}

.pwa-install-btn:disabled {
  opacity: 0.6;
  cursor: default;
}

.pwa-install-later {
  border: 1px solid var(--border);
  background: transparent;
  color: var(--text-secondary);
}

.pwa-install-later:hover {
  background: var(--bg-toolbar);
  color: var(--text-primary);
}

/* En pantallas de mano la banda se parte en dos filas: texto arriba y botones
   abajo, para que «Instalar» no quede a 120 px de ancho. */
@media (max-width: 560px) {
  .pwa-install {
    flex-wrap: wrap;
    align-items: flex-start;
  }

  .pwa-install-text {
    flex-grow: 1;
    flex-shrink: 1;
    flex-basis: calc(100% - 50px);
  }

  .pwa-install-actions {
    width: 100%;
    justify-content: flex-end;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/InstallAppPrompt.css"],"names":[],"mappings":"AAAA;;;;;;EAME;;AAEF;EACE,eAAe;EACf,aAAa;EACb,cAAc;EACd,wDAAwD;EACxD,aAAa;EACb,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,uBAAuB;EACvB,+BAA+B;EAC/B,mBAAmB;EACnB,6BAA6B;EAC7B,0BAA0B;EAC1B,4BAA4B;EAC5B,oCAAoC;AACtC;;AAEA;EACE,OAAO,UAAU,EAAE,2BAA2B,EAAE;EAChD,OAAO,UAAU,EAAE,wBAAwB,EAAE;AAC/C;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,UAAU;EACV,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,yCAAyC;EACzC,qCAAqC;AACvC;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,SAAO;EACP,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,iBAAiB;EACjB,iBAAiB;EACjB,4BAA4B;AAC9B;;AAEA;EACE,kBAAkB;EAClB,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,UAAU;AACZ;;AAEA;;EAEE,kBAAkB;EAClB,wBAAwB;EACxB,aAAa;EACb,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,SAAS;EACT,sEAAsE;EACtE,WAAW;AACb;;AAEA;EACE,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,+BAA+B;EAC/B,uBAAuB;EACvB,4BAA4B;AAC9B;;AAEA;EACE,6BAA6B;EAC7B,0BAA0B;AAC5B;;AAEA;2DAC2D;AAC3D;EACE;IACE,eAAe;IACf,uBAAuB;EACzB;;EAEA;IACE,YAA2B;IAA3B,cAA2B;IAA3B,6BAA2B;EAC7B;;EAEA;IACE,WAAW;IACX,yBAAyB;EAC3B;AACF","sourcesContent":["/* Banda inferior de instalación de la PWA.\r\n *\r\n * Flota por encima del contenido (z-index 1200: debajo de los modales, que van\r\n * en 9000) y respeta la zona segura del iPhone (`env(safe-area-inset-bottom)`).\r\n * Usa `--bg-surface` (opaca) y no `--bg-card`, que en los skins Lumina es\r\n * translúcida y dejaría el texto ilegible sobre un plano o una tabla.\r\n */\r\n\r\n.pwa-install {\r\n  position: fixed;\r\n  left: 0.75rem;\r\n  right: 0.75rem;\r\n  bottom: calc(0.75rem + env(safe-area-inset-bottom, 0px));\r\n  z-index: 1200;\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 0.75rem;\r\n  padding: 0.7rem 0.85rem;\r\n  border: 1px solid var(--border);\r\n  border-radius: 14px;\r\n  background: var(--bg-surface);\r\n  color: var(--text-primary);\r\n  box-shadow: var(--shadow-lg);\r\n  animation: pwa-install-in 0.22s ease;\r\n}\r\n\r\n@keyframes pwa-install-in {\r\n  from { opacity: 0; transform: translateY(12px); }\r\n  to   { opacity: 1; transform: translateY(0); }\r\n}\r\n\r\n.pwa-install-icon {\r\n  width: 38px;\r\n  height: 38px;\r\n  flex: none;\r\n  display: grid;\r\n  place-items: center;\r\n  border-radius: 10px;\r\n  background: rgba(var(--accent-rgb), 0.16);\r\n  color: var(--accent-l, var(--accent));\r\n}\r\n\r\n.pwa-install-icon svg {\r\n  width: 26px;\r\n  height: 26px;\r\n}\r\n\r\n.pwa-install-text {\r\n  flex: 1;\r\n  min-width: 0;\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 2px;\r\n  font-size: 0.8rem;\r\n  line-height: 1.35;\r\n  color: var(--text-secondary);\r\n}\r\n\r\n.pwa-install-text strong {\r\n  font-size: 0.88rem;\r\n  color: var(--text-primary);\r\n}\r\n\r\n.pwa-install-actions {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 0.4rem;\r\n  flex: none;\r\n}\r\n\r\n.pwa-install-btn,\r\n.pwa-install-later {\r\n  border-radius: 9px;\r\n  padding: 0.45rem 0.85rem;\r\n  font: inherit;\r\n  font-size: 0.82rem;\r\n  font-weight: 700;\r\n  cursor: pointer;\r\n  white-space: nowrap;\r\n}\r\n\r\n.pwa-install-btn {\r\n  border: 0;\r\n  background: linear-gradient(135deg, var(--accent), var(--accent-dark));\r\n  color: #fff;\r\n}\r\n\r\n.pwa-install-btn:disabled {\r\n  opacity: 0.6;\r\n  cursor: default;\r\n}\r\n\r\n.pwa-install-later {\r\n  border: 1px solid var(--border);\r\n  background: transparent;\r\n  color: var(--text-secondary);\r\n}\r\n\r\n.pwa-install-later:hover {\r\n  background: var(--bg-toolbar);\r\n  color: var(--text-primary);\r\n}\r\n\r\n/* En pantallas de mano la banda se parte en dos filas: texto arriba y botones\r\n   abajo, para que «Instalar» no quede a 120 px de ancho. */\r\n@media (max-width: 560px) {\r\n  .pwa-install {\r\n    flex-wrap: wrap;\r\n    align-items: flex-start;\r\n  }\r\n\r\n  .pwa-install-text {\r\n    flex: 1 1 calc(100% - 50px);\r\n  }\r\n\r\n  .pwa-install-actions {\r\n    width: 100%;\r\n    justify-content: flex-end;\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
